import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ViewData from "../importData/ViewData";
import BottomTabBar from "../components/BottomTabBar";
import AppButton from "../components/AppButton";

const ImportDataEdit = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("phone")) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="min-h-[100dvh] bg-gray-50 w-full flex flex-col pb-24 sm:pb-28">
      <div className="flex-1 w-full min-w-0">
        <div className="px-4 sm:px-5 pt-6 pb-2">
          <AppButton
            variant="ghost"
            fullWidth={false}
            onClick={() => navigate("/user-settings")}
            className="mb-2"
          >
            ← Back
          </AppButton>
          <h1 className="text-xl sm:text-2xl font-extrabold text-gray-900">
            View Items
          </h1>
        </div>
        <div className="table_importArea">
          <ViewData />
        </div>
      </div>
      <BottomTabBar />
    </div>
  );
};

export default ImportDataEdit;
